/**
 * UTC calendar-day helpers. The admin-api takes from/to as YYYY-MM-DD in UTC and stores
 * expires_at as epoch ms; a date input's value is a calendar day, so convert through UTC
 * midnight (never through the local timezone, which would shift the day in UTC+8).
 */
const pad = (n: number) => String(n).padStart(2, '0');

/** epoch ms → 'YYYY-MM-DD' (UTC). */
export function utcDay(ms: number): string {
  const d = new Date(ms);
  return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())}`;
}

/** 'YYYY-MM-DD' → epoch ms at UTC midnight, or null when not a real calendar day. */
export function dayToUtcMs(day: string): number | null {
  const m = day.trim().match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return null;
  const y = Number(m[1]);
  const mo = Number(m[2]);
  const d = Number(m[3]);
  const ms = Date.UTC(y, mo - 1, d);
  return utcDay(ms) === `${m[1]}-${m[2]}-${m[3]}` ? ms : null;
}

/** The UTC day `n` days before `now` (n=0 → today). */
export function daysAgo(n: number, now: number = Date.now()): string {
  return utcDay(now - n * 86_400_000);
}
